var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
import MagnifierIcon from "../atoms/icons/Magnifier";
const StyledSearchButton = styled.button `
    background-color: transparent;
    border: none;
    margin-left: 15px;

    &:focus {
        outline: none;
    }
`;
const StyledMagnifierIcon = styled(MagnifierIcon) `
    fill: ${(props) => props.theme.primary};
`;
const SearchButton = (_a) => {
    var props = __rest(_a, []);
    return (React.createElement(StyledSearchButton, Object.assign({}, props),
        React.createElement(StyledMagnifierIcon, null)));
};
export default SearchButton;
